import { CAREER_OFFER_EVENTS } from '../../../../../../src/features/career-offer-analytics/model/events.ts';

const depthThresholds = [25, 50, 75, 90] as const;
const timeThresholds = [15, 30, 60] as const;

export const createCareerOfferEngagementTracker = ({
	emitDepth,
	emitTime,
}: {
	emitDepth: (depth: (typeof depthThresholds)[number]) => void;
	emitTime: (seconds: (typeof timeThresholds)[number]) => void;
}) => {
	const emittedDepths = new Set<number>();
	const emittedTimes = new Set<number>();
	let visibleSeconds = 0;

	return {
		updateScroll(progress: number) {
			const percentage = Math.max(0, Math.min(1, progress)) * 100;
			for (const depth of depthThresholds) {
				if (percentage >= depth && !emittedDepths.has(depth)) {
					emittedDepths.add(depth);
					emitDepth(depth);
				}
			}
		},
		advanceVisibleTime(seconds: number) {
			visibleSeconds += Math.max(0, seconds);
			for (const threshold of timeThresholds) {
				if (visibleSeconds >= threshold && !emittedTimes.has(threshold)) {
					emittedTimes.add(threshold);
					emitTime(threshold);
				}
			}
		},
	};
};

const actionMap = {
	cta_click: CAREER_OFFER_EVENTS.CTA_CLICK,
	dialog_open: CAREER_OFFER_EVENTS.DIALOG_OPEN,
	dialog_close: CAREER_OFFER_EVENTS.DIALOG_CLOSE,
	external_link_click: CAREER_OFFER_EVENTS.EXTERNAL_LINK_CLICK,
	document_click: CAREER_OFFER_EVENTS.EXTERNAL_LINK_CLICK,
	language_select: CAREER_OFFER_EVENTS.LANGUAGE_SELECT,
	back_to_language_selector: CAREER_OFFER_EVENTS.UNAVAILABLE_ACTION,
	go_home: CAREER_OFFER_EVENTS.UNAVAILABLE_ACTION,
	support_click: CAREER_OFFER_EVENTS.EXTERNAL_LINK_CLICK,
	logo_click: CAREER_OFFER_EVENTS.CTA_CLICK,
} as const;

export const getCareerOfferInteractionEvent = (action: string) =>
	actionMap[action as keyof typeof actionMap];
